import { render, staticRenderFns } from "./PaymentCanceledView.vue?vue&type=template&id=a742f68e&"
import script from "./PaymentCanceledView.vue?vue&type=script&lang=ts&"
export * from "./PaymentCanceledView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a742f68e')) {
      api.createRecord('a742f68e', component.options)
    } else {
      api.reload('a742f68e', component.options)
    }
    module.hot.accept("./PaymentCanceledView.vue?vue&type=template&id=a742f68e&", function () {
      api.rerender('a742f68e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/payment/PaymentCanceledView.vue"
export default component.exports